import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const dailyRevenueGraphAction = createAsyncThunk(
    'daily-revenue-graph',
    async (data, { rejectWithValue }) => {
        try {
            // const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/no-of-quit-attempts`)
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/dailyRevenue`,data)

            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const dailyRevenueGraphSlice = createSlice({
    name: 'daily-revenue-graph',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(dailyRevenueGraphAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(dailyRevenueGraphAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(dailyRevenueGraphAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const  dailyRevenueGraphReducer = dailyRevenueGraphSlice.reducer